type ChangeEvent = React.ChangeEvent<
  HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
>;

interface Props {
  form: {
    httpMethod: string;
    requiredPermission: string;
    inputSchemaJson: string;
    isEnabled: boolean;
  };
  onChange: (e: ChangeEvent) => void;
  onFormat: () => void;
}

const McpSchemaField: React.FC<Props> = ({
  form, onChange, onFormat
}) => (
  <>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium mb-1">
          HTTP Method
        </label>
        <select
          name="httpMethod" value={form.httpMethod}
          onChange={onChange}
          className="w-full border rounded-md px-3 py-2 text-sm"
        >
          <option value="GET">GET</option>
          <option value="POST">POST</option>
          <option value="PUT">PUT</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          Required Permission
        </label>
        <input
          name="requiredPermission"
          value={form.requiredPermission}
          onChange={onChange}
          className="w-full border rounded-md px-3 py-2 text-sm"
          required
        />
      </div>
    </div>
    <div>
      <div className="flex items-center justify-between mb-1">
        <label className="block text-sm font-medium">
          Input Schema (JSON)
        </label>
        <button
          type="button" onClick={onFormat}
          className="text-xs text-primary hover:underline"
        >
          Format JSON
        </button>
      </div>
      <textarea
        name="inputSchemaJson"
        value={form.inputSchemaJson}
        onChange={onChange}
        className="w-full border rounded-md px-3 py-2 text-sm font-mono"
        rows={8}
      />
    </div>
    <div className="flex items-center gap-2">
      <input
        type="checkbox" name="isEnabled"
        checked={form.isEnabled} onChange={onChange}
        className="w-4 h-4"
      />
      <label className="text-sm font-medium">Enabled</label>
    </div>
  </>
);

export default McpSchemaField;
